export default __webpack_public_path__ + "static/media/technicalIndicatorItem.6eddbfe2.svg";